import { useMemo } from "react";
import { formatDate, formatearNumeros } from "../../../utils/formatters";
import type { TablaHistorialProps, UseTablaHistorialReturn } from "./types";

export const useTablaHistorial = ({
  datos,
}: TablaHistorialProps): UseTablaHistorialReturn => {
  const historialPagos = useMemo(() => datos.historialPagos ?? [], [datos]);

  return {
    formatDate,
    formatearNumeros,
    historialPagos,
  };
};
